import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import GroupSelector from "@/components/GroupSelector";
import ThemeToggle from "@/components/ThemeToggle";
import LogoComponent from "@/components/LogoComponent";
import { NotificationBell } from "@/components/notifications/NotificationBell";
import { V2ProfileMenu } from "@/components/layout/V2ProfileMenu";
import { V2_NAV_ITEMS } from "@/components/layout/v2NavConfig";
import {
  appMobileHeaderClass,
  appNavGhostButtonClass,
  appNavLinkClass,
  appNavShellClass,
} from "@/components/layout/appNavStyles";

const V2TopNavbar = () => {
  const location = useLocation();
  const { t } = useTranslation();

  return (
    <>
      <nav className={cn("hidden md:block", appNavShellClass)}>
        <div className="max-w-[1600px] mx-auto px-8">
          <div className="grid grid-cols-[1fr_auto_1fr] items-center h-16 gap-4">
            <div className="flex items-center gap-6 min-w-0 justify-self-start">
              <LogoComponent to="/v2/home" />
              <div className="min-w-[200px] max-w-[300px]">
                <GroupSelector />
              </div>
            </div>

            <div className="flex items-center gap-1 justify-self-center">
              {V2_NAV_ITEMS.map((item) => {
                const active = location.pathname.startsWith(item.href);
                const name = t(item.nameKey);

                return (
                  <Link
                    key={item.href}
                    to={item.href}
                    aria-label={name}
                    className={appNavLinkClass(active)}
                  >
                    <item.icon className="w-4 h-4" />
                    <span>{name}</span>
                  </Link>
                );
              })}
            </div>

            <div className="flex items-center gap-1.5 justify-self-end">
              <NotificationBell />
              <ThemeToggle className={appNavGhostButtonClass} />
              <span
                className="h-6 w-px bg-border/70 dark:bg-white/15 shrink-0"
                aria-hidden
              />
              <V2ProfileMenu />
            </div>
          </div>
        </div>
      </nav>

      <div className={appMobileHeaderClass}>
        <LogoComponent to="/v2/home" />
        <div className="flex-1 min-w-0">
          <GroupSelector />
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <NotificationBell />
          <V2ProfileMenu />
        </div>
      </div>
    </>
  );
};

export default V2TopNavbar;
